export default class visualState {
  constructor(key) {
    this.debug = true;
    this.key = key;
    this.storageKey = "visualState" + this.key;
    this.data = {};
    this.init();
  }
  init = () => {
    this.data = JSON.parse(localStorage.getItem(this.storageKey) || "{}");
  };
  read = (propName, defaultValue) => {
    return this.data.hasOwnProperty(propName)
      ? this.data[propName]
      : defaultValue;
  };
  save = (saveData = {}) => {
    let data = Object.assign(this.data, saveData);
    localStorage.setItem(this.storageKey, JSON.stringify(data));
  };
}
